module.exports = __webpack_public_path__ + "05f849b1c68082b958a4d3c0e292edf4.jpg";